<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('newGroup') >= 0,
        'last-active': opened.indexOf('newGroup') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createGroup()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novaSkupina") }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.group" class="text-danger">
          {{ errors.group }}
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">
            <div class="side-box__content__label__withTooltip">
              <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_nazevSkupiny'" />
              {{ $t("nazevSkupiny") }}
            </div>
          </span>
          <div
            :class="{ 'has-error': errors.group && !group.deviceGroupName }"
            class="side-box__content__input custom-control__custom-input ml-3"
          >
            <span v-if="!group.deviceGroupName" class="placeholder">{{ $t("zadejteNazevSkupiny") }}</span>
            <input
              v-model="group.deviceGroupName"
              autofocus
              class="w-100"
              maxlength="30"
              minlength="1"
              placeholder=""
              type="text"
            />
          </div>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">
            <div class="side-box__content__label__withTooltip">
              <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_popisSkupiny'" />
              {{ $t("popisSkupiny") }}
            </div>
          </span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <span v-if="!group.deviceGroupDesc" class="placeholder">{{ $t("zadejtePopisSkupiny") }}</span>
            <input v-model="group.deviceGroupDesc" autofocus class="w-100" maxlength="255" placeholder="" type="text" />
          </div>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">
            <div class="side-box__content__label__withTooltip">
              <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_hardware'" />
              {{ $t("HARDWARE") }}
            </div>
          </span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: false
                }"
                class="custom-control__select__selected"
              >
                {{ $t("HARDWARE_SELECT") }}
              </div>
            </div>
          </div>
        </div>

        <HwRequestButton @open-box="openBox('hwRequest')" />
        <!--div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("popis") }}</span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <span v-if="!group.custDestDescription" class="placeholder">{{ $t("volitelnyPopisGroupu") }}</span>
            <input
              type="text"
              class="w-100"
              v-model="group.custDestDescription"
              placeholder=""
              autofocus
            />
          </div>
        </div-->
        <!--div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("protokol") }}</span>
          <div class="side-box__content__input custom-control__select ml-3">
              <div class="custom-control__select__selected" v-bind:class="{'opened':protocolOpened}" @click="protocolOpened = protocolOpened ? false : true">
                <span v-if="!protocol" class="gray-text">{{ $t("vyberteProtokolZeSeznamu") }}</span>
                <span v-else>{{ protocol }}</span></div>
              <div class="custom-control__select__options" v-bind:class="{'opened':protocolOpened}">
                <div class="custom-control__select__option d-flex align-items-center">
                  <span class="font-weight-light" @click="protocol = 'REST';protocolOpened = false">REST</span>
                </div>
                <div class="custom-control__select__option d-flex align-items-center">
                  <span class="font-weight-light" @click="protocol = 'MQTT';protocolOpened = false">MQTT</span>
                </div>
              </div>
          </div>
        </div-->

        <!--div class="mt-4 side-box__row d-flex">
          <span class="side-box__content__label mt-sm-5"></span>
          <div class="ml-3 pt-3 w-100 side-box__content__input border-top"><p><a>{{ $t("zkusitPing") }}</a></p></div>
        </div-->
        <div class="d-flex side-box__row align-items-start">
          <span class="side-box__content__label mt-sm-5 pt-4">
            <div class="side-box__content__label__withTooltip">
              <InfoQuestionMark :info-tooltip-text="'tooltip_novaSkupina_pripojitKEndpointu'" />
              {{ $t("pripojitKEndpointu") }}
            </div>
          </span>
          <div class="w-100 side-box__content__input border-top ml-3 pt-4">
            <div class="text-right ml-3">
              <a @click="openBox('newEndpoint')">{{ $t("novyEndpoint") }}</a>
            </div>
            <div class="side-box__content__groups mb-1">
              <div
                v-for="selectedE in selectedEndpoints"
                :key="selectedE.deviceGroupId"
                class="d-flex side-box__content__group justify-content-between mb-2"
              >
                <span class="mr-1 link-gray font-weight-normal">
                  <span>{{ selectedE.custDestName }}</span>
                </span>
                <div class="pointer" @click="addRemoveEndpoint(selectedE)">
                  <img class="" src="@/assets/icons/actions/ico-ico-delete-gray.svg" />
                </div>
              </div>
            </div>
            <div
              v-if="selectedEndpoints.length < 1 || selectGroupVisible == true"
              class="side-box__content__input custom-control__select"
            >
              <div
                :class="{ opened: groupsOpened }"
                class="side-box__content__input custom-control__select__selected"
                @click="groupsOpened = groupsOpened ? false : true"
              >
                <span class="gray-text">{{ $t("vyberteEndpointZeSeznamu") }}</span>
              </div>
              <div :class="{ opened: groupsOpened }" class="custom-control__select__options">
                <div
                  v-for="endpoint in loadedEndpoints"
                  :key="endpoint.custDestId"
                  @click="
                    () => {
                      addRemoveEndpoint(endpoint)
                      selectGroupVisible = false
                    }
                  "
                >
                  <div
                    v-if="!(selectedEndpoints.filter((e) => e.custDestId === endpoint.custDestId).length > 0)"
                    class="custom-control__select__option d-flex align-items-center"
                  >
                    <div class="check">
                      <img v-if="selectedEndpoints.indexOf(endpoint) > -1" class="" src="@/assets/icons/check.svg" />
                    </div>
                    <span class="font-weight-light">{{ endpoint.custDestName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <a v-if="selectedEndpoints.length < loadedEndpoints.length" class="" @click="selectGroupVisible = true">
                {{ $t("pridatDalsiEndpoint") }}
              </a>
            </div>
          </div>
        </div>
        <!--div class="my-4">
          <a
            @click="parametersTagsOpened = parametersTagsOpened ? false : true"
            :class="{ opened: parametersTagsOpened }"
            class="atom-form-group__toggler"
            >{{ $t("parametryATagy")
            }}<img
              src="@/assets/icons/arrows/arr-orange-down.svg"
              class="atom-form-group__toggler__arrow"
          /></a>
          <div
            class="atom-form-group__content"
            :class="{ opened: parametersTagsOpened }"
          >
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{
                $t("vlastniParametry")
              }}</span>
              <div class="side-box__content__input custom-control__select ml-3">
                <div
                  class="custom-control__select__selected"
                  v-bind:class="{ opened: parametersOpened }"
                  @click="parametersOpened = parametersOpened ? false : true"
                >
                  <span
                    v-if="selectedParameters.length < 1"
                    class="gray-text"
                    >{{ $t("vyberteZeSvychParametru") }}</span
                  >
                  <span v-else
                    ><span
                      class="mr-1"
                      v-for="(selectedParameter, index) in selectedParameters"
                      :key="index"
                      >{{ selectedParameter
                      }}<span v-if="index < selectedParameters.length - 1"
                        >,</span
                      ></span
                    ></span
                  >
                </div>
                <div
                  class="custom-control__select__options"
                  v-bind:class="{ opened: parametersOpened }"
                >
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="addRemoveParameter('Parametr1')"
                  >
                    <div class="check">
                      <img
                        src="@/assets/icons/check.svg"
                        class=""
                        v-if="selectedParameters.indexOf('Parametr1') > -1"
                      />
                    </div>
                    <span class="font-weight-light">Parametr1</span>
                  </div>
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="addRemoveParameter('Parametr2')"
                  >
                    <div class="check">
                      <img
                        src="@/assets/icons/check.svg"
                        class=""
                        v-if="selectedParameters.indexOf('Parametr2') > -1"
                      />
                    </div>
                    <span class="font-weight-light">Parametr2</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("tagy") }}</span>
              <div
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!writtenGroupTags" class="placeholder">{{
                  $t("zadejteTag")
                }}</span>
                <input
                  type="text"
                  class="w-100"
                  v-model="writtenGroupTags"
                  placeholder=""
                  autofocus
                />
              </div>
            </div>
          </div>
        </div-->
      </div>
    </div>
    <div
      :class="{
        opened: opened.indexOf('newEndpoint') >= 0,
        'last-active': opened.indexOf('newEndpoint') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createEndpoint">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritEndpoint") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novyEndpoint") }}</h2>
      </div>

      <NewEndpointFormFields
        :endpoint="newEndpoint"
        :errors="errors"
        :opened="opened"
        @close-box="closeBox"
        @open-box="openBox"
      />
    </div>

    <HwRequestModal :opened="opened" />

    <SaveConfirmationModal
      :opened="openedGroupConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupConfirmation"
      @no="closeBox()"
      @yes="createGroup()"
    />
    <SaveConfirmationModal
      :opened="openedEndpointConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointConfirmation"
      @no="
        () => {
          closeBox('newEndpoint')
          clearEndpoint()
        }
      "
      @yes="createGroup()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            closeBox()
          }
        "
      />
    </div>
    <div v-if="errorsToTranslate1.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate1" :opened="openedError1" @close="openedError1 = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import InfoQuestionMark from "@/components/info/infoQuestionMark.vue"

import NewEndpointFormFields from "@/components/modals/endpoints/NewEndpointFormFields.vue"
import HwRequestModal from "@/components/modals/hardware/new-request.vue"
import HwRequestButton from "@/components/modals/hardware/opening-button.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    NewEndpointFormFields,
    SaveConfirmationModal,
    ErrorModal,
    InfoQuestionMark,
    HwRequestModal,
    HwRequestButton
  },
  props: {
    tags: Array,
    //groups: Array,
    opened: Array
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      group: {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      },
      protocolOpened: false,
      loadedEndpoints: [],
      selectedEndpoints: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      //selectedGroupTags: [],
      selectedGroupTags: [],
      groupTags: [],
      //writtenGroupTags: "",
      writtenGroupTags: "",
      protocol: "",
      newEndpoint: {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {},
        custDestEnabled: true,
        transformationId: null
      },
      openedEndpointConfirmation: false,
      openedGroupConfirmation: false,
      errors: {
        group: "",
        endpoint: ""
      },
      selectGroupVisible: false,
      errorsToTranslate: [],
      openedError: false,
      openedError1: false,
      errorsToTranslate1: []
    }
  },
  computed: {
    isEndpointValid() {
      if (!this.newEndpoint.protocol) {
        return false
      }

      if (this.newEndpoint.protocol === "HTTP") {
        return this.newEndpoint.custDestName && this.newEndpoint.custDestParameters.url
      }

      if (this.newEndpoint.protocol === "MQTT") {
        return this.newEndpoint.custDestName && this.newEndpoint.custDestParameters.address
      }

      return false
    },
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    slides() {},
    project() {
      if (this.project && this.opened.indexOf("newGroup") > -1) {
        this.loadEndpoints();
        this.setProject();
      }
    },
    writtenGroupTags() {
      this.createTagsArray()
    },
    opened() {
      if (this.opened.indexOf("newGroup") > -1) {
        this.loadEndpoints()
        this.setProject()
      }
    }
  },
  mounted() {
    if (this.project) {
      this.loadEndpoints()
      this.setProject()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      console.log(box)
      if (box == undefined) {
        this.resetValues()

        this.$emit("closeBox", "newGroup")
      } else if (box == "newGroup") {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        this.errors.endpoint = ""
        this.emptyEndpoint()
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      this.group.projectId = this.project.projectId
      this.newEndpoint.projectId = this.project.projectId
    },
    loadEndpoints() {
      axios
        .get(process.env.VUE_APP_API + "/http/endpoints?search=" + this.project.projectId + "&limit=1000", {})
        .then((result) => {
          this.loadedEndpoints = result.data.data
        })
        .catch(() => {})
    },
    addRemoveEndpoint(group) {
      if (this.selectedEndpoints.indexOf(group) == -1) {
        this.selectedEndpoints.push(group)
      } else {
        this.selectedEndpoints.splice(this.selectedEndpoints.indexOf(group), 1)
      }
      //
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) == -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    addRemoveTag(tag) {
      if (this.writtenGroupTags.indexOf(tag) == -1) {
        this.writtenGroupTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenGroupTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedGroupTags = selected
    },
    createGroup() {
      this.setProject()
      this.errorsToTranslate = []
      if (this.group.deviceGroupName && this.group.projectId) {
        axios
          .post(process.env.VUE_APP_API + "/device-groups", this.group, {
            /*headers: {
                authorization: "Basic cGl4bWFuOnBpeG1hbg==",
                sessionId: this.sessionId
              }*/
          })
          .then((result) => {
            let groupId = result.data.deviceGroupId
            let selectedEndpointsId = this.selectedEndpoints.map((d) => d.custDestId)
            if (selectedEndpointsId.length < 1) {
              this.$emit("reloadItems")
              //this.emptyGroup();
            } else {
              let promises = []
              this.selectedEndpoints.forEach((endpoint) => {
                promises.push(
                  axios
                    .post(
                      process.env.VUE_APP_API +
                        "/device-groups/" +
                        groupId +
                        "/endpoints/" +
                        endpoint.custDestId +
                        "/assign",
                      {}
                    )
                    .then(
                      /*result*/ () => {
                        //this.emptyGroup();
                        //this.$emit('reloadItems');
                      }
                    )
                    .catch((error) => {
                      this.errorsToTranslate.push(error.data)
                    })
                )
              })
              Promise.all(promises).then(() => {
                this.openedError = true
                this.$emit("reloadItems")
              })
            }
            this.closeBox()
          })
          .catch((error) => {
            this.errorsToTranslate.push(error.data)
            if (this.errorsToTranslate.length > 0) {
              this.openedError = true
            } else {
              this.closeBox()
            }
          })
      } else {
        this.errors.group = this.$t("fillAllFieldsError")
      }
    },
    clearEndpoint() {
      this.newEndpoint = {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {
          url: "",
          auth: "",
          headers: {
            "Content-Type": "application/json"
          }
        },
        custDestEnabled: true,
        transformationId: null
      }
      this.errors.endpoint = ""
      this.setProject()
    },
    async createEndpoint() {
      this.errorsToTranslate1 = []

      if (this.isEndpointValid) {
        const postUrl = `${process.env.VUE_APP_API}${
          this.newEndpoint.protocol === "HTTP" ? "/http/endpoints" : "/mqtt/gateways"
        }`

        try {
          const result = await axios.post(postUrl, this.newEndpoint)

          let endpointId = result.data.custDestId

          let createdEndpoint = Object.assign(this.newEndpoint)
          createdEndpoint.custDestId = endpointId
          this.clearEndpoint()
          this.loadedEndpoints.push(createdEndpoint)
          this.selectedEndpoints.push(createdEndpoint)

          this.$emit("closeBox", "newEndpoint")
        } catch (error) {
          this.errorsToTranslate1.push(error.data)
          this.openedError1 = true
        }
      } else {
        this.errors.endpoint = this.$t("fillAllFieldsError")
      }
    },
    getAllTags() {
      //let tags = _.uniqBy(this.allGroups,'tags')
      //this.tags = _.flatMap(this.allGroups, 'tags');
      this.groupTags = _(this.loadedEndpoints)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
      //
      /*let tags = _.uniqBy(this.allGroups,'deviceGroups');
      this.tags = _.map(tags, _.property('deviceGroups.deviceGroupName'));
        */
    },
    toggleEndpointConfirmation() {
      this.openedEndpointConfirmation = this.openedEndpointConfirmation ? false : true
    },
    toggleGroupConfirmation() {
      this.openedGroupConfirmation = this.openedGroupConfirmation ? false : true
    },
    resetValues() {
      this.group = {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      }
      this.protocolOpened = false
      this.groupsOpened = false
      this.parametersTagsOpened = false
      this.parametersOpened = false
      this.tagsOpened = false
      this.errors.group = ""
      this.selectedEndpoints = []
    },
    emptyEndpoint() {
      this.errors.endpoint = ""
      this.newEndpoint = {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {
          url: "",
          auth: "",
          headers: {
            "Content-Type": "application/json"
          }
        },
        custDestEnabled: true,
        transformationId: null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
